<template>
  <div class="row">
  <div class="toprow">
      <button type="button" class="btn" @click="showModal">
        New Card
      </button>
      <div id="checkboxes">
          <label class="cbox-lab">
            <input type="checkbox" class="cbox" id="allcbox" v-model="allchk" @click="checkAll()">
            <span class="clab-text">
              All
            </span>
          </label>
          <label class="cbox-lab">
            <input type="checkbox" class="cbox" id="homecbox" v-model="homechk" @change="updateCheckall()">
            <span class="clab-text">
              Home
            </span>
          </label>
          <label class="cbox-lab">
            <input type="checkbox" class="cbox" id="anycbox" v-model="anychk" @change="updateCheckall()">
            <span class="clab-text">
              Anywhere
            </span>
          </label>
          <label class="cbox-lab">
            <input type="checkbox" class="cbox" id="errandscbox" v-model="errchk" @change="updateCheckall()">
            <span class="clab-text">
              Errands
            </span>
          </label>
          <label class="cbox-lab">
            <input type="checkbox" class="cbox" id="workcbox" v-model="workchk" @change="updateCheckall()">
            <span class="clab-text">
              Work
            </span>
          </label>
      </div>
  </div>
    <div class="col-3" v-for="(element) in board" :key="element.title">
      <KBList :title=element.title :content=element.data :chks=homechk></KBList>
    </div>
    <div id="right-col">
      <div class="donearea">
        <h4>Done</h4>
        <draggable class="done" :list="donelist" group="cards" @add="movedDone">
        </draggable>
      </div>

    </div>
    <modal v-show="isModalVisible" @close="closeModal"/>
    <editmodal :oldTitle="editTitle" :oldNotes="editNotes" :oldCategory="editCat" :oldId="editIdnum" v-show="isEditModalVisible" @close="closeEditModal"/>
  </div>
</template>

<script>
import axios from 'axios'
import KBList from './KB-List.vue'
import modal from './New-KB-Modal.vue'
import editmodal from './Edit-KB-Modal.vue'
import draggable from 'vuedraggable'

export default {
  name: 'Kanban',
  components: {
    KBList,
    modal,
    editmodal,
    draggable
  },
  data() {
    return {
      board: null,
      cache_board: null,
      waiting: false,
      frozen: false,
      isModalVisible: false,
      isEditModalVisible: false,
      editTitle: 'temp',
      editNotes: 'temp',
      editCat: 'temp',
      editIdnum: 99,
      editIdx: Array,
      donelist: [],
      allchk: true,
      homechk: true,
      anychk: true,
      errchk: true,
      workchk: true,
      kb_url: String,
      move_url: String,
      newcard_url: String,
      editcard_url: String,
      done_url: String
    };
  },
  methods: {
    confirmAction: function() {
      this.cache_board = JSON.parse(JSON.stringify(this.board))
    },
    undoAction: function() {
      this.board = JSON.parse(JSON.stringify(this.cache_board))
    },
    showModal: function() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    showEditModal: function(editTitle, editNotes, editCat, editId) {
      this.findEditCard(editId);
      this.editTitle = editTitle;
      this.editNotes = editNotes;
      this.editCat = editCat;
      this.editIdnum = editId;
      this.isEditModalVisible = true;
    },
    closeEditModal() {
      this.isEditModalVisible = false;
    },
    findEditCard: function(editId) {
      for (let i = 0; i < Object.keys(this.board).length; i++) {
        for (let j = 0; j < Object.keys(this.board[i]['data']).length; j++) {
          if (this.board[i]['data'][j]['id'] == editId) {
            this.editIdx = [i, j];
          }
        }
      }
    },
    addCard: function(newcard, callback) {
      this.board["0"]["data"].push(newcard);
      callback();
    },
    updateCard: function(updatecard, callback) {
      this.board[this.editIdx[0]]['data'][this.editIdx[1]]['title'] = updatecard['title'];
      this.board[this.editIdx[0]]['data'][this.editIdx[1]]['description'] = updatecard['description'];
      this.board[this.editIdx[0]]['data'][this.editIdx[1]]['category'] = updatecard['category'];
      this.board[this.editIdx[0]]['data'][this.editIdx[1]]['id'] = updatecard['id'];
      callback();
    },
    deleteCard: function(callback) {
      this.board[this.editIdx[0]]['data'].splice(this.editIdx[1],1);
      callback();

    },
    freeze: function() {
      if (this.waiting == true) {
        this.frozen = true
      }
    },
    movedDone: function(evt) {
      this.waiting = true;
      setTimeout(this.freeze, 100);

      var out_data = new FormData();
      out_data.set('id', this.donelist[evt.newIndex].id);

      axios.post(this.done_url,
        out_data
      ).then(response => {
        if (response.status == 200) {
          this.confirmAction();
          this.waiting = false;
          this.frozen = false;
        }
        else {
          this.undoAction();
          this.waiting = false;
          this.frozen = false;
        }
      }).catch(err => {
        window.console.log(err);
        this.undoAction();
        this.waiting = false;
        this.frozen = false;
      })
    },
    checkAll: function() {
      this.homechk = !this.allchk;
      this.anychk = !this.allchk;
      this.errchk = !this.allchk;
      this.workchk = !this.allchk;
      this.allchk = !this.allchk;
    },
    updateCheckall: function() {
      this.allchk = this.homechk & this.anychk & this.errchk & this.workchk;
    }
  },
  mounted: function() {
    if (this.$parent.$parent.$vnode.tag.includes('DummyDashboard')) {
      this.kb_url = "https://brain-backend-qsyqs6472a-ts.a.run.app/v1/dummy_kanban"
      this.move_url = "https://brain-backend-qsyqs6472a-ts.a.run.app/v1/success_dummy"
      this.newcard_url = "https://brain-backend-qsyqs6472a-ts.a.run.app/v1/new_card_dummy"
      this.editcard_url = "https://brain-backend-qsyqs6472a-ts.a.run.app/v1/success_dummy"
      this.done_url = "https://brain-backend-qsyqs6472a-ts.a.run.app/v1/success_dummy"
      this.del_url = "https://brain-backend-qsyqs6472a-ts.a.run.app/v1/success_dummy"
    }
    else {
      this.kb_url = "https://brain-backend-qsyqs6472a-ts.a.run.app/v1/get_kanban"
      this.move_url = "https://brain-backend-qsyqs6472a-ts.a.run.app/v1/success_move"
      this.newcard_url = "https://brain-backend-qsyqs6472a-ts.a.run.app/v1/new_card"
      this.editcard_url = "https://brain-backend-qsyqs6472a-ts.a.run.app/v1/edit_card"
      this.done_url = "https://brain-backend-qsyqs6472a-ts.a.run.app/v1/done_card"
      this.del_url = "https://brain-backend-qsyqs6472a-ts.a.run.app/v1/delete_card"
    }
    axios.get(this.kb_url).then(
      response => (
        this.board = response.data,
        this.cache_board = JSON.parse(JSON.stringify(response.data))
      )
    )
  }
};
</script>

<style scoped>
.col-3 {
  display: inline-block;
  margin: 5px 5px 10px 5px;
  float: left;
}
.row {
  min-width: 925px;
  /*max-width:905px;*/
  white-space: nowrap;
  width: 100%;
  height: 660px;
  padding: 0px 5px 0px 5px;
}
#right-col {
  margin: 5px;
  height: 600px;
  display: inline-block;
  float: left;
}
.toprow {
  padding: 0px 5px;
}
/*.fa-check-square {
display: block;
color: #3D96A6;
top: 50%;
left: 50%;
}*/
.card {
  padding: 100px;
  display: none;
}
.btn {
  left: 50%
}
.donearea{
  margin: 0px 0px 5px 0px;
  background-color: #EEEEEE;
  border: 1px solid #444444;
  border-radius: 5px;
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.1);
  height: 600px;
}
.done {
  height: 500px;
  width: 120px;
}
h4 {
  margin: 5px 0px 5px 0px;
  text-align: center;
}
.cbox-lab {
  display: inline-block;
  margin: 0px 0px 0px 20px;
}

#checkboxes {
  display: inline-block;
}
.cbox {
  display: inline;
  vertical-align: middle;
}
.clab-text {
  display: inline;
  vertical-align: middle;
}
</style>
